import { BackButton } from "components/contests/contest-display-items/shared/buttons";
import ContestEntryBalanceView from "components/contests/contest-details/header/contest-entry-balance-view.tsx";
import { ReactComponent as MyPicksIcon } from "icons/MYPICKS.svg";
import { secondaryColor, sparketBlack } from "utils/constants";
import BlockyHeavyText from "components/custom-texts/blocky-heavy-text";
import styles from "components/contests/contest-display-items/shared/styles.module.css";
import { toggle as toggleMyPickState } from "state/slices/my-picks-popout-slice.ts";
import { useAppDispatch, useAppSelector } from "state/hooks.ts";
import { local as localStorage } from "utils/local-storage";
import { Button } from "react-bootstrap";
import ContestEntrySelector from "components/contests/contest-details/header/contest-entry-selector.tsx";
import { ContestEntry } from "interfaces/leaderboard/contest.ts";
import { getCurrentEntryIdByContestId } from "state/slices/contests-slice.ts";

interface Props {
  contestId: string;
  userContestEntries: ContestEntry[];
}

const ContestPageContestViewHeader = ({ contestId, userContestEntries }: Props) => {

  const dispatch = useAppDispatch();

  const currentContestEntryId = useAppSelector(state => getCurrentEntryIdByContestId(state, contestId));

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        height: 37,
        padding: "0 20px"
      }}
    >
      <BackButton
        size="sm"
        backUrl={localStorage.getItem("prevPath") ? `/${localStorage.getItem("prevPath")}` : "/"}
      />

      {currentContestEntryId && (
        <>
          <ContestEntryBalanceView contestEntryId={currentContestEntryId} />

          {userContestEntries.length > 1 && <ContestEntrySelector contestId={contestId} entries={userContestEntries} />}

          <Button
            size="sm"
            onClick={() => dispatch(toggleMyPickState())}
            className={styles.prizeContainer}
            style={{
              padding: "4px 8px",
              backgroundColor: secondaryColor,
              borderColor: secondaryColor,
              color: sparketBlack,
            }}
          >
            <BlockyHeavyText style={{ fontSize: 11 }}>
              <MyPicksIcon style={{ marginRight: 4 }} height={15} width={15} />
              My Picks
            </BlockyHeavyText>
          </Button>
        </>
      )}
    </div>
  );
};

export default ContestPageContestViewHeader;
